export default __webpack_public_path__ + "static/media/MOSAICO-OUCA.48cc64cd.png";